// extracted by mini-css-extract-plugin
module.exports = {"root":"Orders_root__1lQ7E"};